import {
	isTeamAssessmentRoute,
	sharedLinkStateForError
} from '~/utils/assessmentInvitation'
import { reportWorkflowError } from '~/utils/workflowErrorReporting'

function translatedErrorMessage(app, statusCode) {
	const translationStatus = [403, 404, 500].includes(statusCode)
		? statusCode
		: 500
	const translationKey = `error.${translationStatus}.message`

	return app?.i18n?.t?.(translationKey) || translationKey
}

function invitationErrorMessage(app, state) {
	const translationKey = `assessment-invitation.shared-link.${state}.body`

	return app?.i18n?.t?.(translationKey) || translationKey
}

export default async function({ app, $axios, $config, route, store, error }) {
	if (!isTeamAssessmentRoute(route)) {
		return
	}

	if (!$config?.featureFlags?.teamAssessments) {
		return error({
			statusCode: 404,
			message: translatedErrorMessage(app, 404)
		})
	}

	try {
		await $axios.$post(
			`/job-offer/${route.params.id}/assessment-entry`,
			null,
			{ __skipGlobalErrorToast: true }
		)
	} catch (requestError) {
		const statusCode = requestError?.response?.status || 500
		const invitationState = sharedLinkStateForError(requestError)

		if (invitationState) {
			return error({
				statusCode,
				message: invitationErrorMessage(app, invitationState)
			})
		}

		reportWorkflowError(requestError, {
			flow: 'job_offer_assessment',
			operation: 'enter_team_assessment',
			jobOfferId: route.params.id,
			rootState: store.state,
			teamAssessmentMode: true
		})

		return error({
			statusCode,
			message: translatedErrorMessage(app, statusCode)
		})
	}

	try {
		await store.dispatch('user/getUser', {
			skipGlobalErrorToast: true,
			skipOrganizationFetch: true
		})
	} catch (requestError) {
		const statusCode = requestError?.response?.status || 500
		reportWorkflowError(requestError, {
			flow: 'job_offer_assessment',
			operation: 'hydrate_team_assessment_session',
			jobOfferId: route.params.id,
			rootState: store.state,
			teamAssessmentMode: true
		})

		return error({
			statusCode,
			message: translatedErrorMessage(app, statusCode)
		})
	}
}
